const CollectionSlider = {
  "options": {
    "data": {
      "text": {
        "type": "Text",
        "order": 1
      },
      "images": [
        {
          "image": {
            "src": ""
          },
          "pointTo": {
            "url": "",
            "pointTo": "",
            "pointToName": "",
            "pointToType": ""
          }
        }
      ]
    },
    "customization": {
      "textSize": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 2
      },
      "textColor": {
        "type": "HexColor",
        "order": 3
      },
      "textAlignment": {
        "type": "LeftCenterRight",
        "order": 1
      },
      "textStyle": {
        "type": "SelectBox",
        "data": {
          "selectOptions": [
            "normal",
            "italic"
          ]
        },
        "order": 5
      },
      "textWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "order": 6
      },
      "textLetterSpacing": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 7
      },
      "backgroundSize": {
        "type": "Radio",
        "order": 11,
        "data": {
          "direction": "row",
          "radioOptions": [
            "cover",
            "contain",
            "stretch"
          ]
        }
      },
      "boxShadow": {
        "type": "ChildComponentRenderer",
        "order": 12,
        "data": {
          "componentNames": [
            "shadow1",
            "shadow2",
            "shadow3"
          ]
        }
      },
      "imageTextWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "order": 10
      },
      "productTextAlignment": {
        "type": "LeftCenterRight",
        "order": 4
      }
    },
    "widgets": {
      "Tabs_1": {
        "type": "Tabs",
        "order": 8,
        "options": {
          "containerPadding": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "edge"
            },
            "type": "FourPx"
          },
          "padding": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "edge"
            },
            "type": "FourPx"
          },
          "borderRadius": {
            "data": {
              "max": 30,
              "min": 0,
              "step": 1,
              "svgType": "border"
            },
            "type": "FourPx"
          }
        }
      },
      "Tabs_2": {
        "type": "Tabs",
        "order": 10,
        "options": {
          "imageTextControl": {
            "data": {
              "direction": "row",
              "radioOptions": [
                "clip",
                "double",
                "wrap"
              ]
            },
            "type": "Radio"
          },
          "imageTextColor": {
            "type": "HexColor"
          },
          "imageTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            }
          }
        }
      },
      "ToggleRadioTabs_1": {
        "type": "ToggleRadioTabs",
        "order": 9,
        "renderOptions": {
          "controlKey": "backgroundType",
          "direction": "row"
        },
        "options": {
          "backgroundImage": {
            "type": "ImageUploader"
          },
          "backgroundColor": {
            "type": "HexColor"
          }
        }
      }
    }
  },
  "variants": [
    {
      "id": "CollectionSlider_2_1",
      "name": "CollectionSlider_2_1",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "2/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_2_1.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_5_2",
      "name": "CollectionSlider_1_5_2",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "3/4",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_5_2.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_13",
      "name": "CollectionSlider_1_1_13",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_13.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_22",
      "name": "CollectionSlider_1_1_22",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_22.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_2_22",
      "name": "CollectionSlider_1_2_22",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/2",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_2_22.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_30",
      "name": "CollectionSlider_1_1_30",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_30.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_13_round",
      "name": "CollectionSlider_1_1_13_round",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_13_round.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_22_round",
      "name": "CollectionSlider_1_1_22_round",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_22_round.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "CollectionSlider_1_1_30_round",
      "name": "CollectionSlider_1_1_30_round",
      "type": "CollectionSlider",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "borderRadius": "0px 0px 0px 0px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "imageTextWeight": "400",
        "backgroundColor": "#F0EEFB",
        "textLetterSpacing": "0px",
        "containerPadding": "8px 8px 8px 8px",
        "padding": "8px 8px 4px 8px",
        "boxShadow": "shadow1",
        "backgroundImage": "",
        "backgroundType": "-",
        "backgroundSize": "cover",
        "imageTextControl": "clip",
        "imageTextColor": "#7059ef",
        "imageTextSize": "9px",
        "productTextAlignment": "left"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 3,
        "maxImage": 9,
        "modulo": 3
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/CollectionSlider_1_1_30_round.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ],
  "globalSettings": {
    "canUploadVideo": true
  }
}
 export default CollectionSlider